import React from 'react';
import styled from 'styled-components';

import Typography from '@mui/material/Typography';

const EmptyListMessage = () => {
    return (
        <EmptyListContainer>
            <Typography>No track logs found</Typography>
        </EmptyListContainer>
    );
};

const EmptyListContainer = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export default EmptyListMessage;
